export class AUTHGWCONSTANTS {
  public static guestAuth: string = '&%T#@ITU6&$U&&GUESTTOKEN' + window.location.hostname;
  public static xenAuth: string = '&%T#@IKTU76&%$$U&&XENTOKEN' + window.location.hostname;
  public static hash: string = '&%T&HGDMNBV&%$#@K#@76&%$$HASH' + window.location.hostname;
  public static addressObject: any = '&&%TR$#@K#@4UW%$ADDRESS' + window.location.hostname;
  public static serAreaObject: any = '&&%TR$#@K#@4UW%*#%$AREA' + window.location.hostname;
  public static loggedIn: string = '&HG$$JHGFY$#@H&%$H&DLOGIN' + window.location.hostname;
  public static profile = 'KJG&HG$$JHGFY$#@H&%JHJHG&#$PROFILE' + window.location.hostname;
  public static phoneNumber = '';
  public static email = '';
}
